import { createKvSyncModule } from '@ahaslides-product/frontend-toolkit'
import { getKvSyncApi } from '@/api/kvSync'
import kvSyncSubscriber from '@/mqtt/kvSync'
import sentry from '@/services/sentry'

export default createKvSyncModule({
  getKvSyncApi,
  kvSyncMqttSubscriber: kvSyncSubscriber,
  captureException: sentry.captureException,
})
